import React from 'react';

import {EventTrackingProvider} from '@newsela/snitch';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {v4 as uuidv4} from 'uuid';

import {getUser} from 'static/three-oh/src/modules/selectors/userSelectors';

import getPreviousUrl from '../getPreviousUrl';

const propTypes = {
  children: PropTypes.node,
  authenticatedUser: PropTypes.object
};

// For coffee script using uuid
window.uuidv4 = uuidv4;

const EventTrackingProviderSnitch = ({children, authenticatedUser}) => {
  return (
    <EventTrackingProvider
      userInfo={{
        userId: authenticatedUser?.id,
        uniqueUserId: authenticatedUser?.unique_id
      }}
      getPreviousUrl={getPreviousUrl}
      platform="legacy_web"
    >
      {children}
    </EventTrackingProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    authenticatedUser: getUser(state),
  };
};

EventTrackingProviderSnitch.propTypes = propTypes;
export default connect(mapStateToProps)(EventTrackingProviderSnitch);
